<template>
       <HomeHero
          v-if="content"
          :logoUrl="content.logo"
          :imgUrl="content.image_principale"
          :introduction="content.introduction"
          :citation="content.citation" />
        <HomeSavoirFaire v-if="content" :content="content['savoir-faire']" />
        <HomeThemesList v-if="content" :themes="content.competences" />
        <div class="wrapper-background">
        <HomeLastProjects/>
        <HomeBlocTrust/>
        </div>
        <HomeBlocContact v-if="content" :content="content.contact"/>
</template>

<script setup lang="ts">

import type { SiteOptions } from '~/types/options'

const { getContentAcf } = useWordpressApi()

const { data: content, pending } = await useAsyncData<SiteOptions | null>(
  `acf-options`,
  () => getContentAcf()
)

</script>

<style lang="scss" >
        h2{
                font-size: 40px;
                font-weight: 900;
                color: $text_light;
                font-family: 'Playfair Display',serif;
                text-align: center;
                @media screen and (max-width: 1035px) {
                        font-size: 30px;
                        line-height: 34px;
                        margin-bottom: 1rem;
                }
        }
        .wrapper-background{
                background-image: url('~/assets/imgs/fond_1.png');
                background-size: cover;
        }
</style>

